import React from 'react'
import PropTypes from 'prop-types'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import DateInput from '../input/date'
import EditView from 'bstrap-react-mobx-admin/view/edit'
import SelectInput from '../input/select'
import SelectWithSuggestions from '../input/select_suggested'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import { Helmet } from 'react-helmet'

const VATratesEditForm = ({ state }) => {
  const record = state.cv.record
  const errors = state.cv.errors
  const updateField = state.cv.updateData.bind(state.cv)
  const { stageOneRestricted, stageTwoRestricted } = state.timeRestriction.checkEntity(state, record, state.cv.timeRestriction)
  const dateRestriction = state.timeRestriction[state.cv.entityname]
  const entityDisabled = !state.hasRight(defaultConst.ENTNAMES.VATRATES, 'w')
  const disabled = entityDisabled || stageOneRestricted
  const itemName = record.has('region') &&
    state.options.get('Countries') &&
    state.options.get('Countries').find(f => f.value === record.get('region'))

  return (
    <div className='row'>
      <Helmet title={state.__(linkConst.LINK_VATRATES_TITLE).concat(defaultConst.HTML_DIVIDER) + (record.has('id')
        ? ((itemName && itemName.text) || state.__(defaultConst.TITLE_EDIT))
        : state.__(defaultConst.TITLE_CREATE))} />
      <div className='col-sm-12 col-md-8 col-lg-6'>
        <SelectWithSuggestions
          noInputAddon
          label={state.__('region')}
          attr={'region'}
          record={record}
          onChange={updateField}
          optionsrecord={state.options}
          optionsattr={'Countries'}
          labelattr='text'
          valueattr='value'
          errors={errors}
          disabled={disabled} />
        <TextInput type='number' step='0.1'
          label={state.__('rate')}
          attr={'rate'}
          record={record}
          onChange={updateField}
          errors={errors}
          disabled={disabled} />
        <SelectInput
          label={state.__('platform')}
          attr={'platform'}
          record={record}
          labelattr='text'
          valueattr='value'
          onChange={updateField}
          optionsrecord={state.options}
          optionsattr={'Platforms'}
          errors={errors}
          disabled={disabled} />
        <DateInput
          attr={'valid_from'}
          disabled={disabled}
          errors={errors}
          label={state.__('valid from')}
          minDate={dateRestriction.valid_from.minDate}
          onChange={updateField}
          record={record} />
        <DateInput
          attr={'valid_to'}
          disabled={entityDisabled || stageTwoRestricted}
          errors={errors}
          label={state.__('valid to')}
          minDate={dateRestriction.valid_to.minDate}
          onChange={updateField}
          record={record} />
      </div>
    </div>
  )
}
VATratesEditForm.propTypes = {
  state: PropTypes.object.isRequired
}

const VATratesEditView = ({ store }) => {
  if (!store.hasRight(defaultConst.ENTNAMES.VATRATES)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }
  return (
    <EditView
      store={store.cv}
      onReturn2list={store.onReturn2list.bind(store)}
      enabled={store.hasRight(defaultConst.ENTNAMES.VATRATES, 'w')}>
      <VATratesEditForm state={store} />
    </EditView>
  )
}
VATratesEditView.propTypes = {
  store: PropTypes.object.isRequired
}

export default VATratesEditView
